function Button({ onClicked, title = "", isHighlighted = false, icon = null }) {
  return (
    <div
      onClick={onClicked}
      className={`rounded-[4px] flex items-center px-[10px] h-[24px] cursor-pointer justify-center border-borderColor border-[1px] ${
        isHighlighted && "bg-blueColor border-none"
      }`}
    >
      <span
        className={`flex items-center gap-[6px] font-OpenSansRegular text-[12px] font-[600] ${
          isHighlighted ? "text-white" : "text-[#67737E]"
        }`}
      >
        {icon}
        {title}
      </span>
    </div>
  );
}

export default Button;
